export default __webpack_public_path__ + "static/media/netent.73d23894.svg";